import numbro from 'numbro';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { uiHelpers } from '../../helpers';

interface Props {
  interval: string;
  item: any;
}
const VolumeBarChart: React.FC<Props> = ({
  interval: avgVolInterval,
  item,
}) => {
  const WIDTH = 500,
    HEIGHT = 90;

  const { i18n, t } = useTranslation();

  const { volume, [`avgVol${avgVolInterval}`]: avgVol } = item;

  if (avgVol === null) return <span>-</span>;

  const BAR_WIDTH = (WIDTH / 40) * 27;
  const BAR_HEIGHT = WIDTH / 100;
  const BAR_RIGHT_MARGIN = WIDTH / 20;
  const BAR_ORIGIN_X = WIDTH / 20;
  const BAR_ORIGIN_Y_1 = HEIGHT / 2 - BAR_HEIGHT;
  const BAR_ORIGIN_Y_2 = HEIGHT / 2;
  const FONT_SIZE = Math.round(HEIGHT * 0.3);
  const FONT_SIZE_LARGE = Math.round(HEIGHT * 0.4);

  let width1 = BAR_WIDTH;
  let width2 = BAR_WIDTH;

  if (volume > avgVol) width2 *= avgVol / volume;
  if (volume < avgVol) width1 *= volume / avgVol;

  return (
    <svg viewBox={`0 0 ${WIDTH} ${HEIGHT}`}>
      <rect
        x={BAR_ORIGIN_X}
        y={BAR_ORIGIN_Y_1}
        width={width1}
        height={BAR_HEIGHT}
        style={{
          fill: 'red',
        }}
      />
      <rect
        x={BAR_ORIGIN_X}
        y={BAR_ORIGIN_Y_2}
        width={width2}
        height={BAR_HEIGHT}
        style={{
          fill: '#128DFA',
        }}
      />

      <text
        x={BAR_ORIGIN_X}
        y={BAR_ORIGIN_Y_1 - BAR_HEIGHT}
        fontSize={FONT_SIZE}
        textAnchor="start"
      >
        {`${t('Vol')} ` + uiHelpers.formatLargeMoney(i18n, volume)}
      </text>

      <text
        x={BAR_ORIGIN_X}
        y={BAR_ORIGIN_Y_2 + BAR_HEIGHT + FONT_SIZE}
        fontSize={FONT_SIZE}
        textAnchor="start"
      >
        {`${t(avgVolInterval.toString())} ${t('Vol')} ` +
          uiHelpers.formatLargeMoney(i18n, avgVol)}
      </text>

      <text
        x={WIDTH - BAR_RIGHT_MARGIN}
        y={BAR_ORIGIN_Y_1 - FONT_SIZE_LARGE / 2}
        dominantBaseline="hanging"
        fontSize={FONT_SIZE_LARGE}
        textAnchor="end"
      >
        {numbro(volume / avgVol).format('0.00')}
      </text>
    </svg>
  );
};

export default React.memo(VolumeBarChart);
